var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIncreaseArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 13,
    viewBox: "0 0 8 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.52814 0.571555L0.46877 3.92798C0.393028 4.02124 0.378455 4.12319 0.425082 4.23392C0.471771 4.34453 0.556208 4.40007 0.678639 4.40007L2.63662 4.40007L2.63662 12.2043C2.63662 12.2859 2.66279 12.353 2.71524 12.4054C2.76765 12.4577 2.8347 12.484 2.91626 12.484L4.59447 12.484C4.676 12.484 4.74305 12.4578 4.7954 12.4054C4.84781 12.3529 4.87399 12.2858 4.87399 12.2043L4.87399 9.85434L4.87399 4.40001L6.83194 4.40001C6.94864 4.40001 7.03308 4.34438 7.08537 4.23383C7.13218 4.123 7.11448 4.02105 7.03308 3.9278L3.93857 0.571371C3.88034 0.51311 3.81053 0.484055 3.72888 0.484055C3.65332 0.484055 3.5864 0.513294 3.52814 0.571555Z",
    fill: "#34C759"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncreaseArrow);
export default __webpack_public_path__ + "static/media/IncreaseArrow.1a68744e6a43435442cba867b260a04b.svg";
export { ForwardRef as ReactComponent };